import { defineStore } from 'pinia'
import { apiFetch } from '../api'

export const useAuthStore = defineStore('auth', {
  state: () => ({
    user: null,
    ready: false,
  }),
  getters: {
    isAuthenticated: (state) => Boolean(state.user),
    role: (state) => state.user?.role || '',
    mustChangePassword: (state) => Boolean(state.user?.must_change_password),
  },
  actions: {
    clearLocalSession() {
      localStorage.removeItem('writing-demo-token')
      this.user = null
      this.ready = true
    },
    async loadCurrentUser() {
      if (this.ready) return this.user
      const token = localStorage.getItem('writing-demo-token')
      if (!token) {
        this.user = null
        this.ready = true
        return this.user
      }
      try {
        const res = await apiFetch('auth/me')
        if (!res.ok) throw new Error('Not authenticated')
        const data = await res.json()
        this.user = data.user
      } catch {
        localStorage.removeItem('writing-demo-token')
        this.user = null
      } finally {
        this.ready = true
      }
      return this.user
    },
    async login(username, password, role) {
      const res = await apiFetch('auth/login', {
        method: 'POST',
        body: JSON.stringify({ username, password, role }),
      })
      const data = await res.json()
      if (!res.ok) throw new Error(data.error || 'Invalid username or password.')
      if (data.token) localStorage.setItem('writing-demo-token', data.token)
      this.user = data.user
      this.ready = true
      return data.user
    },
    async changeTemporaryPassword(currentPassword, newPassword) {
      const res = await apiFetch('auth/password', {
        method: 'POST',
        body: JSON.stringify({ current_password: currentPassword, new_password: newPassword }),
      })
      const data = await res.json()
      if (!res.ok) throw new Error(data.error || 'Could not change password.')
      localStorage.removeItem('writing-demo-token')
      this.user = null
      window.location.assign('/login')
      return this.user
    },
    async logout() {
      await apiFetch('auth/logout', { method: 'POST' })
      localStorage.removeItem('writing-demo-token')
      this.user = null
    },
  },
})
